import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gamepad2, Users, Plus, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../config/api';
import './GamesPage.css';

function GamesPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [joinCode, setJoinCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCreateLobby = async (gameType) => {
    setLoading(true);
    setError(null);
    try {
      const result = await api.createLobby(gameType);
      navigate(`/games/lobby/${result.lobbyId}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleJoinByCode = async (e) => {
    e.preventDefault();
    if (!joinCode.trim()) return;
    
    setLoading(true);
    setError(null);
    try {
      const result = await api.joinLobbyByCode(joinCode.trim().toUpperCase());
      navigate(`/games/lobby/${result.lobbyId}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="games-page">
      <div className="container">
        <h1>Games</h1>
        
        {error && <div className="error-message">{error}</div>}

        <div className="join-code-section">
          <h2>Join a Game</h2>
          <form onSubmit={handleJoinByCode} className="join-code-form">
            <input
              type="text"
              value={joinCode}
              onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
              placeholder="Enter join code"
              maxLength={6}
              className="join-code-input"
            />
            <button type="submit" disabled={loading || !joinCode.trim()} className="join-code-button">
              <ArrowRight size={20} />
            </button>
          </form>
        </div>

        <div className="games-list">
          <h2>Available Games</h2>
          
          <div className="game-card" onClick={() => !loading && handleCreateLobby('guesswhat')}>
            <div className="game-card-icon">
              <Gamepad2 size={48} />
            </div>
            <div className="game-card-content">
              <h3>Guess What</h3>
              <p>A two-player guessing game. Ask yes/no questions to figure out your opponent's secret image!</p>
              <div className="game-card-meta">
                <span><Users size={16} /> 2 players</span>
              </div>
            </div>
            <button className="game-card-button" disabled={loading}>
              <Plus size={20} />
              <span>Create Lobby</span>
            </button>
          </div>
        </div>

        {!user && (
          <p className="games-note">
            You can play as a guest, but logging in will save your game history.
          </p>
        )}
      </div>
    </div>
  );
}

export default GamesPage;
